import React from "react";
import { ListIncidentCompany } from "./ListIncidentCompany";


import AnalyticIncidentData from "../../../../../api/AnalyticIncidentData";
import { observer } from "mobx-react-lite";
import stateAnalyticApp from "../../../../../state/stateAnalyticApp";
import { AnalyticsIncidentSkeleton } from "../../skeletons/AnalyticsIncidentSkeleton";

export const IncidentCompany = observer(() => {
  const goCard = (e) => {
    AnalyticIncidentData.goCardIncident(e);
  };
  

  if (!stateAnalyticApp.isLoading) {
    return (
      <div className="incident_component">
        <AnalyticsIncidentSkeleton />
      </div>
    );
  }
  if (
    AnalyticIncidentData.incidents !== null &&
    AnalyticIncidentData.incidents.length !== 0
  ) {
    return (
      <div className="incident_component">
        <ListIncidentCompany goCard={goCard} />
      </div>
    );
  } else {
    return (
      <p className="grey_info">Инциденты за выбранный период не найдены</p>
    );
  }
});
